/* eslint-disable react-hooks/exhaustive-deps */
import { CheckOutlined, LoadingOutlined } from '@ant-design/icons';
import LoadableContainer from '@components/LoadableContainer';
import { useHeroApiService } from '@core/hooks';
import { useBreakpoint } from '@core/hooks/useBreakpoint';
import { Space } from 'antd';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';

type Props = {};

const RenderFinishedContent = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}>
      <CheckOutlined style={{ fontSize: 50, color: 'green' }} />
      <div style={{ marginTop: 30, textAlign: 'center' }}>
        <h1>Submitted</h1>
        <p>Your reply will be posted online shortly 🙌</p>
      </div>
    </div>
  );
};

const ApprovalCallbackScreen = (props: Props) => {
  const breakpoint = useBreakpoint();

  const heroApiService = useHeroApiService();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isFinished, setIsFinished] = useState(false);
  const { googleReviewId } = useParams<{ googleReviewId: string }>();

  useEffect(() => {
    const approveResponse = async () => {
      setIsSubmitting(true);
      if (!googleReviewId) return;

      try {
        const res = await heroApiService.approveReviewResponse(googleReviewId);
        if (res) {
          setIsFinished(true);
        }
      } catch (error) {
        console.log(error);
      }
      setIsSubmitting(false);
    };

    approveResponse();
  }, [googleReviewId]);

  return (
    <div
      style={{
        background:
          "url('https://media.istockphoto.com/id/1010335754/photo/photo-blurred-of-coffee-shop-or-modern-library-abstract-bokeh-light.jpg?b=1&s=170667a&w=0&k=20&c=dtuA7ceXXGA8rQWB35shXNPcHPNyWON27plGOLHY6LQ=')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
      }}>
      <div
        style={{
          backgroundColor: 'white',
          padding: '50px 30px',
          boxShadow:
            'box-shadow: box-shadow: rgba(255, 255, 255, 0.1) 0px 1px 1px 0px inset, rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;',
          height: 'fit-content',
          marginTop: 30,
          width: !breakpoint.isDesktop ? 900 : '100%',
          justifyContent: 'center',
          display: 'flex',
        }}>
        <Space direction="vertical" style={{ justifyContent: 'center' }}>
          <LoadableContainer isLoading={isFinished} loadComponent={<RenderFinishedContent />}>
            <LoadableContainer
              isLoading={isSubmitting}
              loadComponent={
                <div style={{ textAlign: 'center', fontSize: 30 }}>
                  <LoadingOutlined />
                </div>
              }>
              <></>
            </LoadableContainer>
          </LoadableContainer>
        </Space>
      </div>
    </div>
  );
};

export default ApprovalCallbackScreen;
